import { DefaultJoinFormPageProps } from 'src/pages/DefaultJoinFormPage'
import { UIInfoSpace } from 'src/types/api'
import icon_skt from 'src/assets/images/rop03/icon_skt.png'
import icon_skt_on from 'src/assets/images/rop03/icon_skt_on.png'
import icon_kt from 'src/assets/images/rop03/icon_kt.png'
import icon_kt_on from 'src/assets/images/rop03/icon_kt_on.png'
import icon_lg from 'src/assets/images/rop03/icon_lg.png'
import icon_lg_on from 'src/assets/images/rop03/icon_lg_on.png'
import styled, { css } from 'styled-components'
import { Link, useSearchParams } from 'react-router-dom'
import { useParamsList } from 'src/hooks/useParamsList.hook'
import { useFormContext } from 'react-hook-form'
import { JoinFormType } from 'src/types/react-hook-form'
import React from 'react'

const ShapeLogoSplitAgency = ({
  resetFormItems,
  layoutsInsert,
  blockTelList,
}: Pick<DefaultJoinFormPageProps, 'resetFormItems' | 'blockTelList'> &
  Pick<UIInfoSpace.UIDataType, 'layoutsInsert'>) => {
  const { pCode, fixedTelecom, requestIdPath, form, telecom } = useParamsList()
  const { getValues, setFocus } = useFormContext<JoinFormType>()

  const [searchParams] = useSearchParams()
  const search_params = `?${searchParams.toString()}`
  const hasBlockTel = (blockTelList?.length ?? 0) > 0

  const getIcon = (telecomValue: '0' | '1' | '2', type: 'default' | 'active') => {
    switch (telecomValue) {
      case '0':
        return type === 'default' ? icon_skt : icon_skt_on
      case '1':
        return type === 'default' ? icon_kt : icon_kt_on
      case '2':
        return type === 'default' ? icon_lg : icon_lg_on
      default:
        return ''
    }
  }

  const checkBoxItemsProps = (telecomValue: '0' | '1' | '2') => ({
    to: `/${form}/${pCode}/${requestIdPath}/${telecomValue}${search_params}`,
    $telecom: telecomValue,
    $fixedTelecom: telecomValue === fixedTelecom,
    $isFixedTelecom: !!fixedTelecom,
    $layoutsInsert_agency_actColor: layoutsInsert?.agency?.actColor,
    $disabled: getValues('TranID') !== '' || blockTelList?.includes(telecomValue),
    $active: telecomValue === telecom,
    $defaultIcon: getIcon(telecomValue, 'default'),
    $activeIcon: getIcon(telecomValue, 'active'),
    $gap: hasBlockTel,
    onClick: () => {
      setFocus('PNumber')
      resetFormItems()
    },
    replace: true,
  })

  return (
    <LogoAgency.Container id="agencyTabList">
      {!blockTelList?.includes('0') && <LogoAgency.CheckBoxItem {...checkBoxItemsProps('0')} />}
      {!blockTelList?.includes('1') && <LogoAgency.CheckBoxItem {...checkBoxItemsProps('1')} />}
      {!blockTelList?.includes('2') && <LogoAgency.CheckBoxItem {...checkBoxItemsProps('2')} />}
    </LogoAgency.Container>
  )
}

export default ShapeLogoSplitAgency

const LogoAgency = {
  Container: styled.div`
    display: flex;
    width: 100%;
    height: 50px;
    gap: 6px;
  `,
  CheckBoxItem: styled(Link)<{
    $isFixedTelecom?: boolean
    $fixedTelecom?: boolean
    $disabled?: boolean
    $layoutsInsert_agency_actColor?: string
    $active?: boolean
    $telecom?: '0' | '1' | '2'
    $defaultIcon: string
    $activeIcon: string
    $gap: boolean
  }>`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: row nowrap;
    flex: 1;
    padding: 12px 10px;
    border-radius: 12px;
    box-sizing: border-box;

    ${(props) =>
      props.$active
        ? css`
            border: 1.5px solid ${props.$layoutsInsert_agency_actColor || '#1A6EFF'};
            background: url(${props.$activeIcon}) no-repeat center/auto 24px;
            background-color: rgba(26, 110, 255, 0.05);
          `
        : css`
            border: 1px solid #ccd0d8;
            background: url(${props.$defaultIcon}) no-repeat center/auto 24px;
            background-color: var(--white);
          `}
  `,
}
